<div class="eurogard-container">

  <mat-card class="card">
    <mat-card-header>
      <mat-card-title i18n>Insufficient Permissions</mat-card-title>
    </mat-card-header>
    <mat-card-content>

      <div class="inner">

        <p i18n>You do not have the required permissions to access this page:</p>

        <ul>

          @for (permission of requiredPermissions$ | async; track permission) {
            <li>{{permission}}</li>
          }

        </ul>

      </div>

    </mat-card-content>
    <mat-card-actions>
      <button [routerLink]="['/']" color="primary" matButton="filled" i18n>Back to Home</button>
      <button (click)="logout()" matButton="outlined" i18n>Logout</button>
    </mat-card-actions>
  </mat-card>

</div>
